export default "__VITE_ASSET__B5O4P4Nc__"